import {HiShieldCheck} from "react-icons/hi";
import Button from "../Button";
import {useContext} from "react";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
const Final=({message,isDisableTitle})=>{
    const serviceContext=useContext(AuthenticationServiceContext);
    const handleRedirect=()=>{
        const price=serviceContext?.process?.payment?.info ? serviceContext.process.payment.info.init_amount :0
        return serviceContext.handleRedirectToDivar({price,status:"success"})
    }
    return  <div>
                    <div className="flex justify-center mt-10">
                        <h1 className="text-3xl text-gray-600  ">
                            ونیفای
                        </h1>
                    </div>
                    <div className="w-11/12 md:w-6/12 mx-auto  flex flex-col mt-5 justify-center items-center  lg:w-5/12 xl:w-4/12 bg-white rounded-lg p-5 ">
                        <HiShieldCheck className="text-5xl mb-7 text-green-500"/>
                        {!isDisableTitle&& <h1 className="font-bold mb-2  ">احراز هویت با موفقیت انجام شد</h1>}
                        <h1 className=" text-center text-sm ">{message ? message : 'افزونه شما با موفقیت روی آگهی درج شد.'}</h1>

                        <Button onClick={handleRedirect} className="mt-5 w-full lg:w-10/12 rounded-lg text-sm" theme="green">بازگشت به دیوار</Button>
                    </div>
            </div>
}
export default Final;